import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Warning: FC<ISvG> = ({ fill = "#fa820f" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.392"
      height="22.02"
      viewBox="0 0 18.392 22.02"
    >
      <path
        d="M107.477,74.871a.745.745,0,0,0-.731.587,1.442,1.442,0,0,1-.288.627,1.087,1.087,0,0,1-.926.339,1.105,1.105,0,0,1-.926-.339,1.442,1.442,0,0,1-.288-.627.749.749,0,1,0-1.461.328,2.744,2.744,0,0,0,5.351,0A.753.753,0,0,0,107.477,74.871Zm7.037-1.923c-.886-1.168-2.629-1.853-2.629-7.083,0-5.368-2.37-7.526-4.58-8.043-.207-.052-.357-.121-.357-.339v-.167a1.411,1.411,0,0,0-1.381-1.415h-.035a1.411,1.411,0,0,0-1.381,1.415v.167c0,.213-.15.288-.357.339-2.215.524-4.58,2.675-4.58,8.043,0,5.23-1.743,5.909-2.629,7.083a1.142,1.142,0,0,0,.915,1.83h16.116A1.143,1.143,0,0,0,114.514,72.948Zm-2.244.334H98.853a.252.252,0,0,1-.19-.42,6.97,6.97,0,0,0,1.208-1.922,13.038,13.038,0,0,0,.823-5.075,8.824,8.824,0,0,1,1.2-4.994,3.692,3.692,0,0,1,2.227-1.588,2.016,2.016,0,0,0,1.07-.6.455.455,0,0,1,.685-.012,2.084,2.084,0,0,0,1.082.616,3.692,3.692,0,0,1,2.227,1.588,8.824,8.824,0,0,1,1.2,4.994,13.038,13.038,0,0,0,.823,5.075,7.049,7.049,0,0,0,1.237,1.95A.238.238,0,0,1,112.27,73.281Z"
        transform="translate(-96.353 -55.9)"
        fill={fill}
      />
    </svg>
  );
};

export default memo(Warning);
